// extracted by mini-css-extract-plugin
export default {"wix-studio-background-color":"K8Tnhc","wixStudioBackgroundColor":"K8Tnhc","wix-studio-cta-color":"EVkV4M","wixStudioCtaColor":"EVkV4M"};